import "./index.css";
import App from "./App";

const FinalChatBotView = () => {
  return <App />;
};
export default FinalChatBotView;
